import UploadIcon from '../../../assets/icons/import-icon-blue-light.svg'
import React from "react";

export default function UploadDocument({ file, onFileChange }) {
    const handleFileChange = (e) => {
        const selected = e.target.files?.[0];
        if (selected) {
            onFileChange(selected);
        }
    };

    const PreviewFile = ({ name, size, isImage, previewUrl, onRemove }) => (
        <div className="mb-3 p-3 bg-success-light border border-success rounded">
            <div className="d-flex justify-content-between align-items-center">
                <a
                    href={previewUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center"
                >
                    {isImage ? (
                        <img
                            src={previewUrl}
                            alt="preview"
                            className="rounded mr-3"
                            style={{ width: "50px", height: "50px", objectFit: "cover" }}
                        />
                    ) : (
                        <div className="bg-primary text-white d-flex align-items-center justify-content-center rounded mr-3" style={{ width: "50px", height: "50px" }}>
                            PDF
                        </div>
                    )}

                    <div>
                        <p className="mb-0 font-weight-bold text-dark">
                            {name}
                        </p>
                        <small className="text-muted">{size}</small>
                    </div>
                </a>

                <button
                    type="button"
                    onClick={onRemove}
                    className="btn btn-sm btn-outline-danger"
                >
                    <i className="fa fa-times"></i>
                </button>
            </div>
        </div>
    );

    return (
        <div className="card">
            <div className="card-body">

                <h5 className="card-title">
                    Upload Slip Payroll
                </h5>

                {!file ? (
                    <div>
                        <input
                            type="file"
                            id="approveFile"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={handleFileChange}
                            className="d-none"
                        />

                        <label
                            htmlFor="approveFile"
                            className="d-flex flex-column align-items-center justify-content-center p-5 border border-dashed border-secondary rounded cursor-pointer hover-border-primary hover-bg-light"
                            style={{ cursor: "pointer" }}
                        >
                            <img src={UploadIcon} alt="Upload" className="mb-2" style={{ height: "24px", width: "24px" }} />
                            <p className="mb-1 font-weight-medium text-muted">
                                Pilih dokumen atau foto
                            </p>
                            <small className="text-muted">
                                PDF, JPG, PNG
                            </small>
                        </label>
                    </div>
                ) : (
                    <PreviewFile
                        name={file.name}
                        size={(file.size / 1024).toFixed(2) + " KB"}
                        isImage={file?.type?.startsWith("image/")}
                        previewUrl={URL.createObjectURL(file)}
                        onRemove={() => onFileChange(null)}
                    />
                )}
            </div>
        </div>
    );
}